import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import Login from "./components/Login";
import Kitchen from "./components/Kitchen";
import PunchCard from "./components/PunchCard";
import TimeInCard from "./components/TimeinCard";
import Exit from "./components/Exit";
import ExitSlip from "./components/ExitSlip";
import MainLayout from "./components/MainLayout";
import TotalPresent from "./components/TotalPresent";
import AdminLayout from "./AdminComponents/AdminLayout";
import Dashboard from "./AdminComponents/dashboard";
import EmployeeList from "./AdminComponents/EmployeeList";
import EmployeeDeleteList from "./AdminComponents/EmployeeDeleteList";
import EmployeeListID from "./AdminComponents/EmployeeListID";
import EmployeeForm from "./AdminComponents/EmployeeForm";
import EmployeeFormEdit from "./AdminComponents/EmployeeFormEdit";
import ProtectedRoute from "./AdminComponents/urlprotect";
import AdminRouteProtect from "./AdminComponents/adminurlprotect";
import KitchenLeavePolicy from "./AdminComponents/KitchenLeavePolicy";
import LeaveCreditsPage from "./AdminComponents/LeaveCreditsPage";
import LeaveRequestPage from "./AdminComponents/LeaveRequestPage";
import LeaveApprovalPage from "./AdminComponents/LeaveApprovalPage";
import LeaveRegister from "./AdminComponents/LeaveRegister";
import EmployeeListAttendance from "./AdminComponents/Employeeattendance";
import EmployeeListAttendanceTest from "./AdminComponents/Employeeattendancetest";
import EmployeeListAttendanceReport from "./AdminComponents/Employeeattendancefinal";
import KitchenList from "./AdminComponents/KitchenList";
import EmployeeDetails from "./AdminComponents/EmployeeDetails";
import AddEmployeeBulk from "./AdminComponents/Bulkupload";
import AddKitchen from "./AdminComponents/AddKitchen";
import EditAttendance from "./AdminComponents/EditAttendance";
import ExitEmployeeDetails from "./AdminComponents/ExitEmployeeDetails";
import GlobalHoliday from "./AdminComponents/GlobalHoliday";
import BlockViewerRoute from "./AdminComponents/BlockViewerRoute";

function App() {
  return (
    <Router>
      <Routes>
        {/* Public route */}
        <Route path="/" element={<Login />} />

        {/* User layout with Header */}
        <Route element={<MainLayout />}>
          <Route
            path="/kitchen"
            element={
              <ProtectedRoute>
                <Kitchen />
              </ProtectedRoute>
            }
          />
          <Route
            path="/punch"
            element={
              <RequireAuth>
                <PunchCard />
              </RequireAuth>
            }
          />
          <Route
            path="/time-in"
            element={
              <RequireAuth>
                <TimeInCard />
              </RequireAuth>
            }
          />
          <Route
            path="/exit"
            element={
              <RequireAuth>
                <Exit />
              </RequireAuth>
            }
          />
          <Route
            path="/exit-slip"
            element={
              <RequireAuth>
                <ExitSlip />
              </RequireAuth>
            }
          />
          <Route
            path="/total-present"
            element={
              <RequireAuth>
                <TotalPresent />
              </RequireAuth>
            }
          />
          <Route
            path="/kitchen-leave-request"
            element={
              <RequireAuth>
                <LeaveRequestPage />
              </RequireAuth>
            }
          />
        </Route>

        <Route element={<AdminLayout />}>
          <Route
            path="/admindashboard"
            element={
              <RequireAuth>
                <Dashboard />
              </RequireAuth>
            }
          />
          <Route
            path="/employeeList"
            element={
              <RequireAuth>
                <EmployeeList />
              </RequireAuth>
            }
          />
          <Route
            path="/employeeList/:id"
            element={
              <RequireAuth>
                <EmployeeListID />
              </RequireAuth>
            }
          />
          <Route
            path="/employeeForm"
            element={
              <RequireAuth>
                <EmployeeForm />
              </RequireAuth>
            }
          />
          <Route
            path="/editemploye/:id"
            element={
              <RequireAuth>
                <BlockViewerRoute><EmployeeFormEdit /></BlockViewerRoute>
              </RequireAuth>
            }
          />
          <Route
            path="/employee-attendance/:date/:id"
            element={
              <RequireAuth>
                <EmployeeListAttendance />
              </RequireAuth>
            }
          />
          <Route
            path="/employee-details/:id"
            element={
              <RequireAuth>
                <EmployeeDetails />
              </RequireAuth>
            }
          />
          <Route
            path="/employee-delete-list"
            element={
              <RequireAuth>
                <EmployeeDeleteList />
              </RequireAuth>
            }
          />
          <Route
            path="/exitEmployeeDetails/:id"
            element={
              <RequireAuth>
                <ExitEmployeeDetails />
              </RequireAuth>
            }
          />
          <Route
            path="/employee-details-test"
            element={
              <RequireAuth>
                <EmployeeListAttendanceTest />
              </RequireAuth>
            }
          />
          <Route
            path="/kitchenlist"
            element={
              <RequireAuth>
                <KitchenList />
              </RequireAuth>
            }
          />
          <Route
            path="/add-kitchen"
            element={
              <RequireAuth>
                <BlockViewerRoute><AddKitchen /></BlockViewerRoute>
              </RequireAuth>
            }
          />
          <Route
            path="/final-attendance-report-emp"
            element={
              <RequireAuth>
                <EmployeeListAttendanceReport />
              </RequireAuth>
            }
          />
          <Route
            path="/add-employee-bulk"
            element={
              <RequireAuth>
                <BlockViewerRoute><AddEmployeeBulk /></BlockViewerRoute>
              </RequireAuth>
            }
          />
          <Route
            path="/edit-attendance/:date/:kithcheniddd/:id"
            element={
              <RequireAuth>
                <BlockViewerRoute><EditAttendance /></BlockViewerRoute>
              </RequireAuth>
            }
          />
          <Route
            path="/kitchen-leave-policy"
            element={
              <RequireAuth>
                <KitchenLeavePolicy />
              </RequireAuth>
            }
          />
          <Route
            path="/leave-credits"
            element={
              <RequireAuth>
                <LeaveCreditsPage />
              </RequireAuth>
            }
          />
          <Route
            path="/leave-request"
            element={
              <RequireAuth>
                <LeaveRequestPage />
              </RequireAuth>
            }
          />
          <Route
            path="/leave-approvals"
            element={
              <RequireAuth>
                <LeaveApprovalPage />
              </RequireAuth>
            }
          />
          <Route
            path="/leave-register"
            element={
              <RequireAuth>
                <LeaveRegister />
              </RequireAuth>
            }
          />
          <Route
            path="/global-holidays"
            element={
              <RequireAuth>
                <GlobalHoliday />
              </RequireAuth>
            }
          />
        </Route>

        {/* Catch all route - redirect to login if not authenticated, or to a default route if authenticated */}
        <Route
          path="*"
          element={<Navigate to="/" replace />}
        />
      </Routes>
    </Router>
  );
}

// Authentication wrapper component
function RequireAuth({ children }) {
  const userId = localStorage.getItem("user_id");

  if (!userId) {
    // Redirect to login page if not authenticated
    return <Navigate to="/" replace />;
  }

  return children;
}

export default App;